import { WITHDRAWAL_TYPE } from '../../../constants/base';

export const ACCOUNT_LIST_REQUEST = 'ACCOUNT_LIST_REQUEST';
export const SET_ACCOUNT_LIST = 'SET_ACCOUNT_LIST';
export const SET_ACCOUNT_PAGE = 'SET_ACCOUNT_PAGE';
export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';
export const SET_SEARCH_STRING = 'SET_SEARCH_STRING';
export const ACCOUNT_DEFAULT_INFO_REQUEST = 'ACCOUNT_DEFAULT_INFO_REQUEST';
export const SET_ACCOUNT_DEFAULT_INFO = 'SET_ACCOUNT_DEFAULT_INFO';
export const ACCOUNT_INVENTORY_INFO_REQUEST = 'ACCOUNT_INVENTORY_INFO_REQUEST';
export const SET_ACCOUNT_INVENTORY_INFO = 'SET_ACCOUNT_INVENTORY_INFO';
export const ACCOUNT_PUNISH_STATUS_UPDATE = 'ACCOUNT_PUNISH_STATUS_UPDATE';
export const ACCOUNT_RESPONSE_MESSAGE = 'ACCOUNT_RESPONSE_MESSAGE';

export const ACCOUNT_CURRENT_POWER_UPDATE_REQUEST = 'ACCOUNT_CURRENT_POWER_UPDATE_REQUEST';

export const ACCOUNT_CURRENT_NICKNAME_UPDATE_REQUEST = 'ACCOUNT_CURRENT_NICKNAME_UPDATE_REQUEST';

export const ACCOUNT_WITHDRAWAL_CANCEL_REQUEST = 'ACCOUNT_WITHDRAWAL_CANCEL_REQUEST';

export const  ACCOUNT_IMMEDIATE_WITHDRAWAL_REQUEST = 'ACCOUNT_IMMEDIATE_WITHDRAWAL_REQUEST';
